export const testStageBaseUrls = {
  CORE_BASE_URL: 'https://api-test.risevision.com',
  STORE_BASE_URL: 'https://api-test.risevision.com/store',
  STORAGE_BASE_URL: 'https://api-test.risevision.com/storage',
  VIEWER_BASE_URL: 'https://widgets.risevision.com/viewer-stage-0',
  TEMPLATES_BASE_URL:
    'https://widgets.risevision.com/staging/templates/PRODUCT_CODE',
  LAYOUTS_BASE_URL: 'https://widgets.risevision.com/staging/layouts',
  SERVICES_BASE_URL: 'https://services-stage.risevision.com',
  SERVICES2_BASE_DOMAIN: 'services2-stage.risevision.com',
};

export const prodBaseUrls = {
  CORE_BASE_URL: 'https://api.risevision.com',
  STORE_BASE_URL: 'https://api.risevision.com/store',
  STORAGE_BASE_URL: 'https://api.risevision.com/storage',
  VIEWER_BASE_URL: 'https://widgets.risevision.com/viewer',
  TEMPLATES_BASE_URL:
    'https://widgets.risevision.com/stable/templates/PRODUCT_CODE',
  LAYOUTS_BASE_URL: 'https://widgets.risevision.com/stable/layouts',
  SERVICES_BASE_URL: 'https://services.risevision.com',
  SERVICES2_BASE_DOMAIN: 'services2.risevision.com',
};

export const betaBaseUrls = {
  CORE_BASE_URL: 'https://api.risevision.com',
  STORE_BASE_URL: 'https://api.risevision.com/store',
  STORAGE_BASE_URL: 'https://api.risevision.com/storage',
  VIEWER_BASE_URL: 'https://widgets.risevision.com/viewer',
  TEMPLATES_BASE_URL:
    'https://widgets.risevision.com/staging/templates/PRODUCT_CODE',
  // Deliberately `stable`, unlike TEMPLATES_BASE_URL above. Layout components
  // render from `stable` unless their `environment` attribute is 'test'
  // (rise-lit-components' rise-layout-wrapper-file), and beta writes
  // 'prod' (environment.production is true), so beta renders stable layouts
  // and must read the matching stable metadata.
  LAYOUTS_BASE_URL: 'https://widgets.risevision.com/stable/layouts',
  SERVICES_BASE_URL: 'https://services.risevision.com',
  SERVICES2_BASE_DOMAIN: 'services2.risevision.com',
};
